import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LeadCreationFormComponent} from './features/lead-creation-form/lead-creation-form/lead-creation-form.component';
import {NavigationComponent} from './features/navigation/navigation/navigation.component';

export const BASE_ROUTE = 'create-lead';

const routes: Routes = [
  {
    path: BASE_ROUTE,
    component: LeadCreationFormComponent,
    pathMatch: 'full'
  },
  {
    path: '**',
    component: NavigationComponent,
  },
];


@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
